import { createUploadLink } from "apollo-upload-client";

import { config } from "../config";

const uploadLink = createUploadLink({
  uri: config.graphqlUrl,
});

export default uploadLink;
